import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { TemplateCategory } from '@/types/WeeklyReport';
import type {
    LucideIcon
} from 'lucide-react';
import { 
    Calendar, 
    Briefcase, 
    FileText, 
    Users, 
    Mail, 
    Home, 
    Folder
} from 'lucide-react';

interface TemplateCategoryBadgeProps {
    category?: TemplateCategory | null;
    categoryId?: string | null;
    categories?: TemplateCategory[];
    size?: 'sm' | 'default';
}

const iconMap: Record<string, LucideIcon> = {
    'calendar': Calendar,
    'briefcase': Briefcase,
    'file-text': FileText,
    'users': Users,
    'mail': Mail,
    'home': Home,
    'folder': Folder,
};

export const TemplateCategoryBadge: React.FC<TemplateCategoryBadgeProps> = ({
    category,
    categoryId,
    categories,
    size = 'default'
}) => {
    // Find category if only ID provided
    const resolvedCategory = category || categories?.find(c => c.id === categoryId);
    
    if (!resolvedCategory) {
        return null;
    }

    const IconComponent = resolvedCategory.icon ? iconMap[resolvedCategory.icon] : Folder;
    const iconSize = size === 'sm' ? 12 : 14;

    return (
        <Badge
            variant="outline"
            className="flex items-center gap-1.5"
            style={{
                borderColor: resolvedCategory.color,
                color: resolvedCategory.color,
                backgroundColor: `${resolvedCategory.color}10`
            }}
        >
            {IconComponent && <IconComponent size={iconSize} />}
            <span className={size === 'sm' ? 'text-xs' : 'text-sm'}>
                {resolvedCategory.name}
            </span>
        </Badge>
    );
};

export default TemplateCategoryBadge;

